export const getFileNameFromContentDisposition = (
  contentDisposition: string,
) => {
  const fileNameRegex = /^attachment; filename="(.*)"$/;
  const fileNameMatch = contentDisposition.match(fileNameRegex);
  if (!fileNameMatch) {
    throw Error("Unknown file received");
  }
  return fileNameMatch[1];
};
